<template>
  <side-bar>
    <template slot="links">
      <sidebar-item :link="{name: 'Dashboard', icon: 'dashboard', path: '/dashboard'}"></sidebar-item>

      <sidebar-item
        :link="{name: 'Reclamación Cliente', icon: 'domain',  path: '/issues/newcustomerissue'}"
      ></sidebar-item>
      <sidebar-item
        :link="{name: 'Reclamación Consumidor', icon: 'shopping_cart', path: '/issues/newconsumerissue'}"
      ></sidebar-item>
      <sidebar-item
        :link="{name: 'Reclamación Proveedor', icon: 'local_shipping', path: '/issues/newproviderissue'}"
      ></sidebar-item>
    </template>
  </side-bar>
</template>

<script>
export default {
  components: {
  }
};
</script>